import { Navigate, Outlet } from 'react-router-dom';

const AuthGuard = () => {
  const sess_user = localStorage.getItem('sess_user');

  if (sess_user) {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;

};

export default AuthGuard;
